export const hasBothCollectiveScopes = (user) => {
    if (!user.scopes)
        return false;

    return user.scopes.includes('ais') && user.scopes.includes('s2e');
};

